import Compressor from 'compressorjs';
import { postAPICall2 } from '../API/axiosMethodCalls';
import { getUser, getToken } from './Common';

/**
 * Compress a photo file client-side
 * Max 5MB check before compression
 */
export const compressPhoto = (file) => {
  return new Promise((resolve, reject) => {
    // Check file size first (5MB max)
    if (file.size > 5 * 1024 * 1024) {
      reject(new Error('Photo exceeds 5MB limit. Please retake the photo.'));
      return;
    }

    // If already small enough AND already JPEG, skip compression
    if (file.size < 200 * 1024 && file.type === 'image/jpeg') {
      resolve(file);
      return;
    }

    new Compressor(file, {
      quality: 0.6,
      maxWidth: 1920,
      maxHeight: 1080,
      convertSize: 0, // convert ALL files to JPEG regardless of size
      mimeType: 'image/jpeg', // force convert PNG → JPEG
      success: (compressedFile) => {
        console.log(`Compressed: ${(file.size / 1024).toFixed(1)}KB → ${(compressedFile.size / 1024).toFixed(1)}KB`);
        resolve(compressedFile);
      },
      error: (err) => {
        console.warn('Compression failed, using original:', err);
        resolve(file);
      }
    });
  });
};

/**
 * Upload a single photo to temp folder
 * Returns temp_path on success
 */
export const uploadTempPhoto = async (file) => {
  try {
    const formData = new FormData();
    formData.append('requester', getUser());
    formData.append('token', getToken().replace(/['"]+/g, ''));
    formData.append('photo', file);

    const response = await postAPICall2(
      process.env.REACT_APP_LINK + 'forms/upload_temp_photo',
      formData
    );

    if (response.data && response.data.temp_path) {
      return { success: true, temp_path: response.data.temp_path };
    }

    return { success: false, error: 'Upload failed' };
  } catch (error) {
    return { success: false, error: error?.message || 'Upload failed' };
  }
};

/**
 * Compress and upload a photo in one step
 * Returns temp_path on success
 */
export const compressAndUpload = async (file, onProgress) => {
  try {
    if (onProgress) onProgress('compressing');
    
    const compressed = await compressPhoto(file);
    
    if (onProgress) onProgress('uploading');
    
    const result = await uploadTempPhoto(compressed);
    
    if (onProgress) onProgress('done');
    
    return result;
  } catch (error) {
    return { success: false, error: error.message };
  }
};